import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, X, Loader2 } from "lucide-react";
import { fetchInvites, sendInvite, revokeInvite } from "@/lib/api";

export default function InvitePanel() {
  const [emails, setEmails] = useState("");
  const [pending, setPending] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => fetchInvites().then(setPending).catch(() => toast.error("Nu am putut încărca invitațiile"));
  useEffect(() => {
    load();
  }, []);

  const send = async (e) => {
    e.preventDefault();
    const list = emails.split(/[\s,;]+/).map((x) => x.trim()).filter(Boolean);
    if (!list.length) return;
    setBusy(true);
    const failed = [];
    for (const email of list) {
      await sendInvite(email).catch((err) => failed.push(`${email}: ${err.response?.data?.detail || "eroare"}`));
    }
    setBusy(false);
    const ok = list.length - failed.length;
    if (ok) toast.success(`${ok} ${ok === 1 ? "invitație trimisă" : "invitații trimise"}`);
    failed.forEach((f) => toast.error(f));
    setEmails("");
    load();
  };

  const revoke = async (id) => {
    await revokeInvite(id).then(() => toast.success("Invitație anulată")).catch(() => toast.error("Nu am putut anula"));
    load();
  };

  return (
    <section className="invite-box" data-testid="invite-panel">
      <h3>Invită agenți</h3>
      <p className="st-hint">Scrie unul sau mai multe emailuri (separate prin virgulă). Fiecare agent primește un email cu un link: dă click, își alege parola și intră direct ca agent.</p>
      <form onSubmit={send} className="invite-form">
        <textarea
          value={emails}
          onChange={(e) => setEmails(e.target.value)}
          placeholder="agent1@firma.ro, agent2@firma.ro"
          rows={2}
          data-testid="invite-emails-input"
        />
        <button type="submit" className="st-btn st-btn--silver" disabled={busy || !emails.trim()} data-testid="invite-send-btn">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} Trimite invitațiile
        </button>
      </form>
      {pending.length > 0 && (
        <ul className="invite-list" data-testid="invite-pending-list">
          {pending.map((i) => (
            <li key={i.id} data-testid={`invite-row-${i.id}`}>
              <span>{i.email}</span>
              <em>în așteptare</em>
              <button type="button" onClick={() => revoke(i.id)} title="Anulează" data-testid={`invite-revoke-${i.id}`}>
                <X size={14} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
